export default {
  setShow (state, show) {
    state.show = show;
  },
};
